
    import React from 'react';
    import EnchentesRSListPageContainer from './EnchentesRSListPageContainer';
    
    export class EnchentesRSListPage extends React.Component{
        
        render(){
          return (
            <EnchentesRSListPageContainer {...this.props}/>
          )
        }
    }